
const ErrorPage = () => {
  return (
    <div className="error-screen d-flex flex-column justify-content-center align-items-center vh-100">
      <div className="text-center">
        <h1 className="display-4 fw-bold mb-3 text-danger">
          ¡Los sorteos han terminado por hoy!
        </h1>
        <p className="lead mb-4">
          Gracias por participar en nuestros sorteos. Los juegos han finalizado,
          pero no te preocupes, mañana habrá nuevas oportunidades de ganar
          grandes premios.
        </p>
        <div>
          <button
            className="btn btn-primary btn-lg me-2"
            onClick={() => window.location.reload()}
          >
            Reintentar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;